import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, capitalize, capitalizeWord } from './format'

export function newSalaryCat(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_SALARY_CAT_START", payload: "" })
            
            console.log("new SalaryCat START", {data})
            const res = await axios.post('/salaryCats/new',{data})
            console.log({res});
                        
            if (checkErrorData(res, "CREATE_SALARY_CAT_ERROR", dispatch ) ) {
                res.data.salary_cat_name = capitalizeWord(res.data.salary_cat_name)
				dispatch({ type: "NEW_SALARY_CAT", payload: res.data })
				dispatch({ type: "CREATE_SALARY_CAT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new salaryCat ", err);
            dispatch({
                type: "CREATE_SALARY_CAT_ERROR",
                payload: err
            })
        }
    }
}

export function fetchSalaryCats() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_SALARY_CATS_START", payload: "" })

            console.log("fetch SalaryCat START")
            const res = await axios.get('/salaryCats/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_SALARY_CATS_ERROR", dispatch ) ) {               
                let list = capitalize(orderByAsc(res.data, "salary_cat_name"), "salary_cat_name")
                dispatch({
                    type: "GET_SALARY_CATS",
                    payload: formatList(list, "salary_cat_id")
                })
                dispatch({ type: "FETCH_SALARY_CATS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get salaryCats list ", err);
            dispatch({ type: "FETCH_SALARY_CATS_ERROR", payload: err })
        }
    }
}

export function updateSalaryCat(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_SALARY_CAT_START", payload: "" })

            console.log("update SalaryCat START")
            const res = await axios.post("/salaryCats/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_SALARY_CAT_ERROR", dispatch ) ) {               
                data.salary_cat_name = capitalizeWord(data.salary_cat_name)
				dispatch({
                    type: "UPDATE_SALARY_CAT",
                    payload: data
                })
				dispatch({ type: "UPDATE_SALARY_CAT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update salaryCat ", err);
            dispatch({
                type: "UPDATE_SALARY_CAT_ERROR",
                payload: err
                
            })
        }
    }
}
